function parseIconHostParamsObject(paramsObj) {
  var queryString = "";

  for (var key in paramsObj) {
    if (Object.prototype.hasOwnProperty.call(paramsObj, key)) {
      var queryValue = parseQueryValue(paramsObj[key].toString());
      var queryStringPrefix = !queryString ? "" : "&";
      queryString += "".concat(queryStringPrefix).concat(key, "=").concat(queryValue);
    }
  }

  return queryString;
}

function parseQueryValue(queryValue) {
  var parsedQueryValue = queryValue.trim();
  parsedQueryValue = parsedQueryValue.replace(" ", "%20");
  parsedQueryValue = parsedQueryValue.replace(":", "%3A");
  parsedQueryValue = parsedQueryValue.replace("/", "%2F");
  return parsedQueryValue;
}

export { parseIconHostParamsObject };
